import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
import officeImage from '../../assets/images/office.jpg'; // Import the office image

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>About Digital Fig</h2>
          <p>Our Expertise and Services</p>
        </motion.div>
        
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="image-container">
              <img src={officeImage} alt="Digital Fig Ltd office workspace" className="about-img" />
            </div>
          </motion.div>
          
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h3><span className="highlight">Digital Fig</span> delivers enterprise-grade web solutions and software development services.</h3>
            
            <p>
              We develop scalable, responsive web applications using modern frameworks and technologies, ensuring optimal performance and exceptional user experiences.
            </p>
            
            <p>
              Our portfolio includes work for businesses across diverse industries, providing comprehensive solutions from initial consultation through development and ongoing support.
            </p>
            
            <a href="#contact" className="btn primary-btn">Request a Consultation</a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;